export default __webpack_public_path__ + "static/media/m3a1-grease-gun.cf071934.svg";